import settings from './settings';

function settingLabel(path, context) {
  const byPath = path ? settings[String(path).replace(/^settings\./, '')] : null;
  return byPath || (context ? settings[context] : null) || null;
}

const translators = {
  Settings: settingLabel,
};

export function translate(entity, path, context = null) {
  const translator = translators[entity];

  if (!translator) return null;

  return translator(path, context);
}

export default translate;
